import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
  container: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    margin: '10px 0',
  },
  news: {
    backgroundColor: '#ffbc00',
    fontSize: '12px',
    padding: '2px 8px',
    borderRadius: '15px',
    marginLeft: '8px',
  },
}));
